
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class ProductionGrid extends _Ext.GridBase<ProductionRow, any> {
        protected getColumnsKey() { return 'Production.Production'; }
        protected getDialogType() { return ProductionDialog; }
        protected getIdProperty() { return ProductionRow.idProperty; }
        protected getInsertPermission() { return ProductionRow.insertPermission; }
        protected getLocalTextPrefix() { return ProductionRow.localTextPrefix; }
        protected getService() { return ProductionService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
        }
        protected addButtonClick() {

            let now = new Date();
            var voucherNo = FormatHelper.GetVoucherNo(72);
            this.editItem(<ProductionRow>{
                VoucherNo: voucherNo,
                UserId: Q.Authorization.userDefinition.UserId,
                VoucherTypeId: 72,
                EmployeeId: 0,
                TransDate: now.toString(),
                CompanyId: Q.Authorization.userDefinition.CompanyId,
                FinancialYearId: Q.Authorization.userDefinition.FinancialYearId,
            });
        }
    }
}